module.exports = __webpack_public_path__ + "board_game-a30b9bd9.webp";